import React, {useState} from 'react'
import { NavLink } from 'react-router-dom';
import Live from '../../../../../../../../assets/images/req.png';
import './Certificate.css'

const CertificateAudition = () => {
    const [color, setColor] = React.useState("green");

    function changeColor() {
      setColor("red");
    }
return (
<>



    <div className=" row ">
        

        <div title="Live Now" className="col-md-2 align-items-center justify-content-center Souvenir-bt ">
            <div className="card meetupCard">
                <div className="card-body  align-items-center">
                    <center>
                        <tr>
                            <td className="ad-card-td">
                                <img src={Live} className="ad-card-img-top" alt="..." />
                            </td>
                            <td className="ad-card-td">
                                <h3 className="text-warning bg-dark px-5 py-2 fw-bold rounded-2-3">01</h3>
                            </td>
                        </tr>
                    </center>
                </div>
                <NavLink to='/audition-admin/audition/certificate-request' exact>
                <button activeClassName='active' className="card-footer Souvenir-button AudioSA w-100 " data-bs-toggle="collapse"
                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"> Request for Certificate
                </button>
                </NavLink>
            </div>
        </div><br />

        

        <div title="Live Now" className="col-md-2 align-items-center justify-content-center Souvenir-bt ">
            <div className="card meetupCard">
                <div className="card-body  align-items-center">
                    <center>
                        <tr>
                            <td className="ad-card-td">
                                <img src={Live } className="ad-card-img-top" alt="..." />
                            </td>
                            {/* <td className="ad-card-td">
                                <small className="ad-card-small"><b><h3>01</h3></b></small>
                            </td> */}
                        </tr>
                    </center>
                </div>
                
                <NavLink to='/audition-admin/audition/certificate-create'>
                <button className="card-footer Souvenir-button AudioSAA  w-100 " data-bs-toggle="collapse"
                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"> Create Certificate
                </button>
                </NavLink>
            </div>
        </div> <br/>

    </div>
</>
)
}

export default CertificateAudition